import angular from 'angular';
import lmiGoalType from './lmiGoalType';

export default angular
  .module('components.lmiGoalType', [])
  .component('lmiGoalType', lmiGoalType).name;
